import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-carousel-slide',
  templateUrl: './carousel-slide.component.html',
  styleUrls: ['./carousel-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselSlideComponent {
  private static COUNT = 0;
  id: string;

  @HostBinding('role') role = 'option';
  @HostBinding('attr.aria-selected') selected = true;
  @HostBinding('class.carousel-slide--selected') get slide() {
    return this.selected;
  }
  @HostBinding('class.carousel-slide--previous') previous;

  @Input()
  value: string;

  constructor() {
    CarouselSlideComponent.COUNT++;
    this.id = `carousel-slide-${CarouselSlideComponent.COUNT}`;
  }
}
